type VisitsStatistic = {
    id: string;
    card_number: string;
    card_type: string;
    plate_number: string;
    owner_name: string;
    enter_datetime: string;
    exit_datetime: string;
    parking_id: string;
    parking_name: string;
    entry_point: string;
    exit_point: string;
    charge_plan_id: string;
    charge_plan_name?: string;
    price_paid?: number;
    price_collector_id?: string;
    price_collector_name?: string;
    price_paid_time?: string;
    photo_path_entry?: string;
    photo_path_exit: string;
};

enum VISITS_EXPORT_PROPS {
    CARD_NUMBER = 'card_number',
    CARD_TYPE = 'card_type',
    OWNER_NAME = 'owner_name',
    ENTER_DATETIME = 'enter_datetime',
    ENTER_HOUR = 'enter_hour',
    EXIT_DATETIME = 'exit_datetime',
    EXIT_HOUR = 'exit_hour',
    PARKING_NAME = 'parking_name',
    ENTRY_POINT = 'entry_point',
    EXIT_POINT = 'exit_point',
    CHARGE_PLAN_NAME = 'charge_plan_name',
    PRICE_PAID = 'price_paid',
    CURRENCY = 'currency',
    PRICE_PAID_TIME = 'price_paid_time',
    PAID_HOUR = 'paid_hour',
}

import { cardMessages } from 'src/features/cards/utils/messages';
import { statisticsMessages } from 'src/features/statistics/utils/messages';

const VISITS_EXPORT_MESSAGES_MAP = {
    [VISITS_EXPORT_PROPS.CARD_NUMBER]: cardMessages.cardNumber,
    [VISITS_EXPORT_PROPS.CARD_TYPE]: cardMessages.cardType,
    [VISITS_EXPORT_PROPS.OWNER_NAME]: cardMessages.ownerName,
    [VISITS_EXPORT_PROPS.ENTER_DATETIME]: statisticsMessages.enterDate,
    [VISITS_EXPORT_PROPS.ENTER_HOUR]: statisticsMessages.enterHour,
    [VISITS_EXPORT_PROPS.EXIT_DATETIME]: statisticsMessages.exitDate,
    [VISITS_EXPORT_PROPS.EXIT_HOUR]: statisticsMessages.exitHour,
    [VISITS_EXPORT_PROPS.PARKING_NAME]: statisticsMessages.parkingZone,
    [VISITS_EXPORT_PROPS.ENTRY_POINT]: cardMessages.entryPoint,
    [VISITS_EXPORT_PROPS.EXIT_POINT]: cardMessages.exitPoint,
    [VISITS_EXPORT_PROPS.CHARGE_PLAN_NAME]: cardMessages.chargePlan,
    [VISITS_EXPORT_PROPS.PRICE_PAID]: statisticsMessages.paid,
    [VISITS_EXPORT_PROPS.CURRENCY]: statisticsMessages.currency,
    [VISITS_EXPORT_PROPS.PRICE_PAID_TIME]: statisticsMessages.paidDate,
    [VISITS_EXPORT_PROPS.PAID_HOUR]: statisticsMessages.paidHour,
};
export { VISITS_EXPORT_MESSAGES_MAP, VISITS_EXPORT_PROPS };
export type { VisitsStatistic };
